import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './404.css'

const AppComponent = (props) => {
  return (
    <div className="component-container1">
      <img
        alt={props.imageAlt404}
        src={props.imageSrc404}
        className="component-image"
      />
      <span className="component-title">
        {props.title404 ?? (
          <Fragment>
            <span className="component-text6">
              Diese Seite ist verschollen.
            </span>
          </Fragment>
        )}
      </span>
      <span className="component-text1">
        {props.text404 ?? (
          <Fragment>
            <span className="component-text3">
              <span>
                Wir haben alles durchwühlt, aber die gesuchte Seite nicht
                gefunden. Vielleicht können wir aber ein besseres Ziel für dich
                finden.
              </span>
              <br></br>
            </span>
          </Fragment>
        )}
      </span>
      <div className="component-container2">
        <Link to="/" className="component-navlink button">
          <span>
            {props.button404Home ?? (
              <Fragment>
                <span className="component-text7">Zur Startseite</span>
              </Fragment>
            )}
          </span>
        </Link>
      </div>
    </div>
  )
}

AppComponent.defaultProps = {
  imageAlt404: 'image',
  imageSrc404: '/oops-700h.webp',
  text404: undefined,
  title404: undefined,
  button404Home: undefined,
}

AppComponent.propTypes = {
  imageAlt404: PropTypes.string,
  imageSrc404: PropTypes.string,
  text404: PropTypes.element,
  title404: PropTypes.element,
  button404Home: PropTypes.element,
}

export default AppComponent
